import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Clientcms() {
  return (
    <section className="client_cms p-100" style={{ background: "#f8f8f8" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>Our Clientele for Custom CMS Development</h2>
            <p>
              Our CMS development services empower diverse clients with custom,
              enterprise-grade solutions for superior content management.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="client_logo_main">
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/1.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={259}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/5.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={210}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/6.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={134}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/8.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={71}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/9.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={144}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/10.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={156}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/12.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={80}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/2.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={210}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/3.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={210}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/4.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={210}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/7.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={210}
                    height={70}
                  />
                </div>
              </div>
              <div className="client_logo_item">
                <div className="client_logo_icon">
                  <StaticImage
                    src="../../images/services-usa/cms-development/client-logos/13.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={263}
                    height={70}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientcms;
